// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { SchoolRounded } from "@material-ui/icons";
import { unwrapResult } from '@reduxjs/toolkit';
import { Breadcrumb, Form, Input, notification, Select } from 'antd';
import 'antd/dist/antd.css';
import "assets/css/styles.css";
import titleStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import Button from "components/CustomButtons/Button.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import ErrorModal from "views/Components/ErrorModal";
import { grayColor } from "../../../../assets/jss/material-dashboard-pro-react";
import { fetchAreas } from '../../../../reduxToolkit/features/area/AreaSpecSlice';
import { addNewSubArea, fetchSubAreaById, fetchSubAreas, subAreaUpdate } from '../../../../reduxToolkit/features/subarea/SubAreaSpecSlice';

const useStyles = makeStyles(styles);

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 8,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 16,
    span: 16,
  },
};

export default function CreateAreaPage({ match }) {

  const { id } = match.params

  const { t } = useTranslation();
  const classes = useStyles();
  const useTitleStyles = makeStyles(titleStyles);
  const titleClasses = useTitleStyles();
  const isAddMode = isNaN(id);

  const [name, setName] = useState('')
  const [code, setCode] = useState('')
  const [areaSpec_id, setArea_id] = useState('')
  const [addRequestStatus, setAddRequestStatus] = useState('idle')
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [handledError, setHandledError] = useState("");

  const dispatch = useDispatch()

  const areasStatus = useSelector(state => state.areaSpec.areasStatus)
  const subArea = useSelector((state) => state.subAreaSpec.subArea)
  const areas = useSelector(state => state.areaSpec.areas)

  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(fetchAreas())
  }, [])

  useEffect(() => {
    if (!isAddMode) {
      dispatch(fetchSubAreaById(id))
        .then(unwrapResult)
        .then((x) => {
          form.setFieldsValue({
            name: x.name,
            code: x.code,
            areaSpec_id: x.areaSpec_id
          });
        });
    }
  }, [id]);

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };

  const onFinish = async (values) => {
    const resultAction = await dispatch(
      addNewSubArea({ ...values })
    );
    if (addNewSubArea.fulfilled.match(resultAction)) {
      openNotificationWithIcon("success", `Added successfully`);
      form.resetFields();
      dispatch(fetchSubAreas());
      history.push(`/citrine/configuration/course/subAreas`);
    } else {
      if (resultAction.payload) {
        setHandledError(resultAction.payload);
        handleOpenErrorModal();
      } else {
        setHandledError(resultAction.error);
        handleOpenErrorModal();
      }
    }
  };

  const onFinishUpdate = async (values) => {
    const resultAction = await dispatch(
      subAreaUpdate({
        id: id,
        modified: {
          ...values,
        },
      })
    );
    if (subAreaUpdate.fulfilled.match(resultAction)) {
      openNotificationWithIcon("success", `edit successfully`);
      form.resetFields();
      dispatch(fetchSubAreas());
      history.push(`/citrine/configuration/course/subAreas`);
    } else {
      if (resultAction.payload) {
        setHandledError(resultAction.payload);
        handleOpenErrorModal();
      } else {
        setHandledError(resultAction.error);
        handleOpenErrorModal();
      }
    }
  };

  const canSave = [name, code, areaSpec_id].every(Boolean) && addRequestStatus === 'idle'
  const history = useHistory();

  function onChangeArea(value) {
    setArea_id(value);
  }

  function onBlur() {
    console.log('blur');
  }

  function onFocus() {
    console.log('focus');
  }

  function onSearch(val) {
    console.log('search:', val);
  }

  return (
    <div>
      {isAddMode &&
        <div>
          <GridContainer style={{
            borderBottom: `1px solid  ${grayColor[15]}`,
            borderTop: `1px solid  ${grayColor[15]}`,
          }}
            justify="space-between"
            alignItems="center">
            <GridItem>
              <Breadcrumb separator=">">
                <Breadcrumb.Item >
                  {t('Configurations')}
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/citrine/configuration/course`}>
                    <span > {t('Course Configurations')} </span>
                  </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item >
                  <Link to={`/citrine/configuration/course/subAreas`} style={{ color: "orange" }}>
                    {t('SubAreas')}
                  </Link>
                </Breadcrumb.Item>
              </Breadcrumb>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="info" icon>
                  <CardIcon color="info">
                    <SchoolRounded />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    <span className={titleClasses.title}>{t('Create ')}</span>
                  </h4>
                </CardHeader>
                <CardBody>
                  <Form
                    {...layout}
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <Form.Item
                      name="areaSpec_id"
                      label="Area"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select placeholder="Select Area" allowClear>
                        {areas &&
                          areas.map((r) => (
                            <option key={r.id} value={r.id}>
                              {r.name}
                            </option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="name"
                      label="Name"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item
                      name="code"
                      label="Code"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                      <Button
                        type="primary"
                        style={{ marginRight: "20px" }}
                        color="primary"
                        onClick={() =>
                          history.push(`/citrine/configuration/course/subAreas`)
                        }
                        htmlType="submit"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          <ErrorModal
            open={openErrorModal}
            handleClose={handleCloseErrorModal}
            handledError={handledError}
          />
        </div>
      }
      {!isAddMode && subArea &&
        <div>
          <GridContainer style={{
            borderBottom: `1px solid  ${grayColor[15]}`,
            borderTop: `1px solid  ${grayColor[15]}`,
          }}
            justify="space-between"
            alignItems="center">
            <GridItem>
              <Breadcrumb separator=">">
                <Breadcrumb.Item >
                  {t('Configurations')}
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/citrine/configuration/course`}>
                    <span > {t('Course Configurations')} </span>
                  </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item >
                  <Link to={`/citrine/configuration/course/subAreas`} style={{ color: "orange" }}>
                    {t('SubAreas')}
                  </Link>
                </Breadcrumb.Item>
              </Breadcrumb>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="info" icon>
                  <CardIcon color="info">
                    <SchoolRounded />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    <span className={titleClasses.title}>  {t('Edit')} </span>
                  </h4>
                </CardHeader>
                <CardBody>
                  <Form
                    {...layout}
                    form={form}
                    name="control-hooks"
                    onFinish={onFinishUpdate}
                  >
                    <Form.Item
                      name="areaSpec_id"
                      label="Area"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Select placeholder="Select Area" allowClear>
                        {areas &&
                          areas.map((r) => (
                            <option key={r.id} value={r.id}>
                              {r.name}
                            </option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="name"
                      label="Name"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item
                      name="code"
                      label="Code"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                      <Button
                        type="primary"
                        style={{ marginRight: "20px" }}
                        color="primary"
                        onClick={() =>
                          history.push(`/citrine/configuration/course/subAreas`)
                        }
                        htmlType="submit"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          <ErrorModal
            open={openErrorModal}
            handleClose={handleCloseErrorModal}
            handledError={handledError}
          />
        </div>
      }
    </div>
  );
}


